import styled, { keyframes } from 'styled-components';

const slideUp = keyframes`
  from { transform: translateY(120%); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

export const Banner = styled.div`
  position: fixed;
  left: 12px;
  right: 12px;
  bottom: 12px;
  z-index: 9997;
  background: linear-gradient(145deg, rgba(30, 30, 33, 0.98), rgba(22, 22, 24, 0.98));
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 153, 0, 0.35);
  border-radius: 18px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);
  animation: ${slideUp} 0.4s ease;
  max-width: 540px;
  margin: 0 auto;
`;

export const Inner = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;

  @media (max-width: 480px) {
    flex-wrap: wrap;
  }
`;

export const IconWrap = styled.div`
  flex-shrink: 0;

  img {
    border-radius: 11px;
    display: block;
    image-rendering: pixelated;
  }
`;

export const TextBlock = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Title = styled.div`
  color: var(--white-color);
  font-size: 0.98rem;
  font-weight: 700;
  line-height: 1.25;
`;

export const Subtitle = styled.div`
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.82rem;
  line-height: 1.4;
  margin-top: 2px;
`;

export const IosHint = styled.div`
  margin-top: 8px;
  padding: 8px 10px;
  background: rgba(255, 153, 0, 0.1);
  border: 1px solid rgba(255, 153, 0, 0.25);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.78rem;
  line-height: 1.45;

  strong {
    color: var(--primary-color);
  }
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;

  @media (max-width: 480px) {
    width: 100%;
    justify-content: flex-end;
    margin-top: 4px;
  }
`;

export const DismissButton = styled.button`
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.55);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  padding: 8px 10px;
  white-space: nowrap;

  &:hover {
    color: rgba(255, 255, 255, 0.85);
  }

  &:focus-visible {
    outline: 2px solid var(--primary-color);
    outline-offset: 2px;
    border-radius: 4px;
  }
`;

export const InstallButton = styled.button`
  background: var(--primary-color);
  color: #1a1a1a;
  border: none;
  padding: 9px 20px;
  border-radius: 22px;
  font-size: 0.88rem;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 18px rgba(255, 153, 0, 0.4);
  }

  &:focus-visible {
    outline: 2px solid #fff;
    outline-offset: 2px;
  }
`;
